/*eslint-disable*/
import React, { useEffect, useState } from "react";
import { NavLink as NavLinkRRD, Link, Redirect } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";

// reactstrap components
import { Collapse, DropdownMenu, DropdownItem, UncontrolledDropdown, DropdownToggle, Form, Input, InputGroupAddon, InputGroupText,
  InputGroup, Media, NavbarBrand, Navbar, NavItem, NavLink, Nav, Container, Row, Col,UncontrolledCollapse } from "reactstrap";
import { ArrowDropDown } from "@material-ui/icons";
import CheckPermission from "variables/CheckPermission";

var ps;
const Sidebar = (props)=>{
  const [collapseOpen, setcollapseOpen] = useState(false);
  
  const toggleCollapse = () => { setcollapseOpen(!collapseOpen)} // toggles collapse between opened and closed (true/false)
  const closeCollapse = () => { setcollapseOpen(false)} // closes the collapse

  if(!CheckPermission()){         //check role permission
    return <Redirect to="/" />
  }

  const user = JSON.parse(localStorage.getItem("user"));

  const { bgColor, routes, logo } = props;
  let navbarBrandProps;
  if (logo && logo.innerLink) {
      navbarBrandProps = {
        to: logo.innerLink,
        tag: Link,
      };
  } else if (logo && logo.outterLink) {
      navbarBrandProps = {
        href: logo.outterLink,
        target: "_blank",
      };
  }

  const getLinks = (links)=>{
    return links.map((link=>{
      return(<NavItem key={link.link}>
        <NavLink
          to={link.link}
          tag={NavLinkRRD}
          onClick={closeCollapse}
          activeClassName="active"
        >        
          <i className={link.icon + " " + link.iconColor} />
          {link.text}
        </NavLink>
      </NavItem>)
    }))
    
}
  const normalLinks = [
    {link:"/admin/index",text:"Dashboard",icon:"ni ni-tv-2",iconColor:"text-primary"},
    {link:"/admin/profile",text:"User Profile",icon:"ni ni-single-02",iconColor:"text-yellow"},
    {link:"/admin/new/user",text:"Add New User",icon:"ni ni-single-02",iconColor:"text-blue"},
    ]
  const adminLinks = [
    {link:"/admin/employee/table",text:"Employees",icon:"ni ni-badge",iconColor:"text-pink"},
    {link:"/admin/users",text:"Job Applicants",icon:"ni ni-badge",iconColor:"text-pink"},
    {link:"/admin/editschedule",text:"Edit Schedule",icon:"ni ni-calendar-grid-58",iconColor:"text-blue"},
    {link:"/admin/clockin",text:"Employee Clock In",icon:"ni ni-calendar-grid-58",iconColor:"text-blue"},
    {link:"/admin/payroll",text:"Payroll",icon:"ni ni-credit-card",iconColor:"text-yellow"},
    {link:"/admin/accommodation",text:"Accommodation",icon:"ni ni-building",iconColor:"text-blue"},
    /*{link:"/admin/rentals",text:"Villa Rentals",icon:"ni ni-building",iconColor:"text-black"},*/
  ]
  const ticketLinks = [
    {link:"/admin/events",text:"Events",icon:"ni ni-building",iconColor:"text-black"},
    {link:"/admin/events/reports",text:"Comission Reports",icon:"ni ni-building",iconColor:"text-black"},
    {link:"/admin/events/reportsbyevent",text:"Comission By Event",icon:"ni ni-building",iconColor:"text-black"},
    {link:"/admin/events/report/table",text:"Report Table",icon:"ni ni-building",iconColor:"text-green"},
    {link:"/admin/events/report/stats",text:"Report Stats",icon:"ni ni-building",iconColor:"text-green"},
    {link:"/admin/events/reportsales",text:"Ticket Sales",icon:"ni ni-building",iconColor:"text-black"},
    {link:"/admin/events/newreportsales",text:"New Ticket Sales",icon:"ni ni-building",iconColor:"text-black"},
    {link:"/admin/events/nicereport",text:"Nice Report",icon:"ni ni-building",iconColor:"text-black"},
    {link:"/admin/events/reports/online/sales",text:"Online Sales",icon:"ni ni-building",iconColor:"text-black"},
    {link:"/admin/events/reports/vip",text:"VIP Tables",icon:"ni ni-building",iconColor:"text-black"},
    {link:"/admin/events/permissions",text:"Seller Permissions",icon:"ni ni-building",iconColor:"text-green"},
    {link:"/admin/events/shop",text:"Ticket Shop",icon:"ni ni-building",iconColor:"text-green"},
  ]
  const merchLinks = [
    {link:"/admin/shop",text:"Merch Shop",icon:"ni ni-building",iconColor:"text-black"},
    {link:"/admin/shop/addproduct",text:"Merch Create Product",icon:"ni ni-building",iconColor:"text-black"},
    {link:"/admin/shop/reports",text:"Reports",icon:"ni ni-building",iconColor:"text-black"},
    {link:"/admin/shop/cashup",text:"Cashup",icon:"ni ni-building",iconColor:"text-black"},
  ]
  const socialLinks = [
    {link:"/admin/whatsapp",text:"WhatsApp",icon:"ni ni-building",iconColor:"text-black"},
  ]
  const automationLinks = [
    {link:"/admin/automation",text:"Automation",icon:"ni ni-building",iconColor:"text-black"},
  ]

  return(
    <Navbar
        className="navbar-vertical fixed-left navbar-light bg-white"
        expand="md"
        id="sidenav-main"
      >
        <Container fluid>
          {/* Toggler */}
          <button
            className="navbar-toggler"
            type="button"
            onClick={toggleCollapse}
          >
            <span className="navbar-toggler-icon" />
          </button>
          {/* Brand */}
          {logo ? (
            <NavbarBrand className="pt-0" {...navbarBrandProps}>
              <img
                alt={logo.imgAlt}
                className="navbar-brand-img"
                src={logo.imgSrc}
              />
            </NavbarBrand>
          ) : null}
          {/* User */}
          <Nav className="align-items-center d-md-none justify-content-end">
            <UncontrolledDropdown nav>
              <DropdownToggle nav className="nav-link-icon">
                <i className="ni ni-bell-55" />
              </DropdownToggle>
              <DropdownMenu
                aria-labelledby="navbar-default_dropdown_1"
                className="dropdown-menu-arrow"
                end
              >
                <DropdownItem>Action</DropdownItem>
                <DropdownItem>Another action</DropdownItem>
                <DropdownItem divider />
                <DropdownItem>Something else here</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav>
              <DropdownToggle nav>
                <Media className="align-items-center">
                  <span className="avatar avatar-sm rounded-circle">
                    <img alt="..." src={user.test} />
                  </span>
                </Media>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" end>
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Welcome!</h6>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-single-02" />
                  <span>My profile</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-settings-gear-65" />
                  <span>Settings</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-calendar-grid-58" />
                  <span>Activity</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-support-16" />
                  <span>Support</span>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem href="#pablo" onClick={(e) => e.preventDefault()}>
                  <i className="ni ni-user-run" />
                  <span>Logout</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
          {/* Collapse */}
          <Collapse navbar isOpen={collapseOpen}>
            {/* Collapse header */}
            <div className="navbar-collapse-header d-md-none">
              <Row>
                {logo ? (
                  <Col className="collapse-brand" xs="6">
                    {logo.innerLink ? (
                      <Link to={logo.innerLink}>
                        <img alt={logo.imgAlt} src={logo.imgSrc} />
                      </Link>
                    ) : (
                      <a href={logo.outterLink}>
                        <img alt={logo.imgAlt} src={logo.imgSrc} />
                      </a>
                    )}
                  </Col>
                ) : null}
                <Col className="collapse-close" xs="6">
                  <button
                    className="navbar-toggler"
                    type="button"
                    onClick={toggleCollapse}
                  >
                    <span />
                    <span />
                  </button>
                </Col>
              </Row>
            </div>
            {/* Form */}
            <Form className="mt-4 mb-3 d-md-none " style={{justifyContent:'end'}} >
              <InputGroup className="input-group-rounded input-group-merge">
                <Input
                  aria-label="Search"
                  className="form-control-rounded form-control-prepended"
                  placeholder="Search"
                  type="search"
                />
                {/*<InputGroupAddon addonType="prepend">*/}
                  <InputGroupText>
                    <span className="fa fa-search" />
                  </InputGroupText>
                {/*</InputGroupAddon>*/}
              </InputGroup>
            </Form>
            {/* Navigation */}
            <Nav navbar>{/*Normal LINKS GO HERE */}

              
                  {getLinks(normalLinks)}
               
                
            
            </Nav>
            {/* Divider */}
            <hr className="my-3" />
            <h6 className="navbar-heading text-muted" id="togglerAdmin">ADMIN<ArrowDropDown/></h6>
            {/* API links */}
            <Nav navbar>{/*Admin LINKS GO HERE */}

              <UncontrolledCollapse toggler="#togglerAdmin">
                 {getLinks(adminLinks)}
              </UncontrolledCollapse>
            
            </Nav>
            {/* Divider */}
            <hr className="my-3" />
            <h6 className="navbar-heading text-muted" id="togglerTicket">Ticket Sales<ArrowDropDown/></h6>
            
            {/* Ticket links */}
            <Nav navbar>{/*Ticket LINKS GO HERE */}

                  <UncontrolledCollapse toggler="#togglerTicket">
                    {getLinks(ticketLinks)}
                  </UncontrolledCollapse>
            
            </Nav>
            {/* Divider */}
            <hr className="my-3" />
            <h6 className="navbar-heading text-muted" id="togglerMerch">Merch Shop<ArrowDropDown/></h6>
            {/* Ticket links */}
            <Nav navbar>{/*Ticket LINKS GO HERE */}
            
                <UncontrolledCollapse toggler="#togglerMerch">
                 {getLinks(merchLinks)}
                </UncontrolledCollapse>

            </Nav>
            {/* Divider */}
            <hr className="my-3" />
            <h6 className="navbar-heading text-muted" id="togglerSocial">Social<ArrowDropDown/></h6>
            {/* Ticket links */}
            <Nav navbar>{/*Ticket LINKS GO HERE */}
            
                <UncontrolledCollapse toggler="#togglerSocial">
                 {getLinks(socialLinks)}
                </UncontrolledCollapse>

            </Nav>

            {/* Divider */}
            <hr className="my-3" />
            <h6 className="navbar-heading text-muted" id="togglerAutomation">Automation<ArrowDropDown/></h6>
            {/* Ticket links */}
            <Nav navbar>{/*Ticket LINKS GO HERE */}

              <UncontrolledCollapse toggler="#togglerAutomation">
                <NavItem key='Cameras'>
                  <div dangerouslySetInnerHTML={{__html: '<a href="http://celebrationjump.com/testcameras" target="_blank"><i className="ni-camera-compact" /> Cameras </a>'}}/>
                </NavItem>
                    {getLinks(automationLinks)}
              </UncontrolledCollapse>
            </Nav>
          </Collapse>
        </Container>

      </Navbar>
  )
}


Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  //routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;
